import { connectInfiniteHits } from 'react-instantsearch-dom';
import { AlgoliaHit } from '~/templates/blocks/components/Carousel/models';
import { HitCarousel, Props } from '../../../components';

export const CarouselHits = connectInfiniteHits<Props, AlgoliaHit>(HitCarousel);
